/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './insurance-claim-history.reducer';

export const InsuranceClaimHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const insuranceClaimHistoryEntity = useAppSelector(state => state.insuranceClaimHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="insuranceClaimHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.detail.title">InsuranceClaimHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimHistoryEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.status">Status</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimHistoryEntity.status}</dd>
          <dt>
            <span id="paymentStatus">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.paymentStatus">Payment Status</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimHistoryEntity.paymentStatus}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {insuranceClaimHistoryEntity.microSec ? (
              <TextFormat value={insuranceClaimHistoryEntity.microSec} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {insuranceClaimHistoryEntity.timestampEntry ? (
              <TextFormat value={insuranceClaimHistoryEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {insuranceClaimHistoryEntity.lastUpdated ? (
              <TextFormat value={insuranceClaimHistoryEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{insuranceClaimHistoryEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.insuranceClaimHistory.claim">Claim</Translate>
          </dt>
          <dd>{insuranceClaimHistoryEntity.claim ? insuranceClaimHistoryEntity.claim.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/insurance-claim-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/insurance-claim-history/${insuranceClaimHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InsuranceClaimHistoryDetail;
